import useQuery, { QueryOptions } from "../../common/lib/fetch/useQuery";
import { useKaEmployee } from "../../userAccess/kaEmployee/useKaEmployee";

export interface Order {
  id: string;
  number: string;
  orderNumbers: string[];
  customers: string[];
  products: string[];
  destinations: string[];
  availableToRequest: string;
  doNotBlend: boolean;
  bays: string[];
}

export interface GetOrdersResponse {
  orders: Order[];
  loadoutGroups: Order[];
}

export const useGetOrders = (siteId: string, options?: QueryOptions<GetOrdersResponse>) => {
  const kaEmployee = useKaEmployee();
  return useQuery<GetOrdersResponse>({
    headers: kaEmployee.fetchHeaders,
    path: `/api/employee/sites/${siteId}/orders`,
  }, options);
}